import * as React from "react";
import type { SVGProps } from "react";
const SvgApplicationRejectedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <mask
      id="a"
      width={26}
      height={26}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#999" stroke="#900" d="M.5.5h23v23H.5z" />
    </mask>
    <g mask="url(#a)">
      <mask
        id="b"
        width={26}
        height={26}
        x={0}
        y={1}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path fill="currentColor" stroke="#900" d="M.5 1.5h23v23H.5z" />
      </mask>
      <g stroke="#C00" strokeWidth={0.021} mask="url(#b)">
        <path
          fill="#075553"
          d="M12 2.81q.847 0 1.481.51t.833 1.282l-.03.009H18.6q.738 0 1.264.525T20.39 6.4v3.3a.87.87 0 0 1-.255.634.85.85 0 0 1-.63.256.87.87 0 0 1-.635-.256.86.86 0 0 1-.26-.634V6.39h-1.82V8.5a.86.86 0 0 1-.256.634.86.86 0 0 1-.634.256H8.1a.86.86 0 0 1-.634-.256.86.86 0 0 1-.256-.634V6.39H5.39v13.22h4.503a.876.876 0 0 1 .897.884.87.87 0 0 1-.256.636.86.86 0 0 1-.635.26H5.394q-.74 0-1.262-.527a1.73 1.73 0 0 1-.521-1.263V6.4q0-.738.525-1.264.526-.525 1.264-.525h4.275v.03l.01-.038q.199-.772.834-1.282t1.482-.51Zm.005 1.78a.9.9 0 0 0-.65.26.87.87 0 0 0-.266.644q0 .385.261.65a.87.87 0 0 0 .645.266.9.9 0 0 0 .65-.26.87.87 0 0 0 .266-.645.9.9 0 0 0-.261-.65.87.87 0 0 0-.645-.265Z"
        />
        <path
          fill="#C00"
          d="M12 2.81q.847 0 1.481.51t.833 1.282l-.03.009H18.6q.738 0 1.264.525T20.39 6.4v3.3a.87.87 0 0 1-.255.634.85.85 0 0 1-.63.256.87.87 0 0 1-.635-.256.86.86 0 0 1-.26-.634V6.39h-1.82V8.5a.86.86 0 0 1-.256.634.86.86 0 0 1-.634.256H8.1a.86.86 0 0 1-.634-.256.86.86 0 0 1-.256-.634V6.39H5.39v13.22h4.503a.876.876 0 0 1 .897.884.87.87 0 0 1-.256.636.86.86 0 0 1-.635.26H5.394q-.74 0-1.262-.527a1.73 1.73 0 0 1-.521-1.263V6.4q0-.738.525-1.264.526-.525 1.264-.525h4.275v.03l.01-.038q.199-.772.834-1.282t1.482-.51Zm.005 1.78a.9.9 0 0 0-.65.26.87.87 0 0 0-.266.644q0 .385.261.65a.87.87 0 0 0 .645.266.9.9 0 0 0 .65-.26.87.87 0 0 0 .266-.645.9.9 0 0 0-.261-.65.87.87 0 0 0-.645-.265Z"
        />
      </g>
    </g>
    <path
      stroke="#C00"
      strokeLinecap="round"
      strokeWidth={2}
      d="M14.666 15.063c-.005 0 .084.032.605.345.428.281 1.189.81 1.99 1.452.802.642 1.621 1.382 2.532 2.195"
    />
    <path
      stroke="#C00"
      strokeLinecap="round"
      strokeWidth={2}
      d="M19.124 14.582c-.009 0-.643.415-2.09 1.48a43 43 0 0 0-2.437 2.11c-.63.593-.871.882-1.146 1.219"
    />
  </svg>
);
export default SvgApplicationRejectedIcon;
